module.exports = __webpack_public_path__ + "static/media/IMG_3527.804448fc.JPG";